
<div class="container my-4 contactContent" id="">
  <h3 class="page-title">{{'ContactAssessor.TitleSpecific'|translate}}</h3>
  <p style="font-style: italic"><strong>{{'ContactAssessor.Number'|translate}} </strong></p>
  <hr>
    <form [formGroup]="contactForm" (ngSubmit)="submit()">
      <p class="form-label">{{'ContactAssessor.Name'|translate}} <span class="color-red">*</span></p>
      <div class="form-row" style="display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 10px; margin-bottom: 20px;">
        <div class="form-group col-md-6" style="display: flex; flex-direction: column; align-items: center; width: 49%;">

          <input type="text" formControlName="firstName" class="form-control" id="inputFirst-General" placeholder="{{'ContactAssessor.FirstName' | translate}}">
          <div class="invalid-feedback" style="display: block">
            @if (hasError('firstName', 'required')) {
              {{'ContactAssessor.Required'|translate}}
            }
          </div>
        </div>
        <div class="form-group col-md-6">
          <input type="text" formControlName="lastName" class="form-control" id="inputLast-General" placeholder="{{'ContactAssessor.LastName' | translate}}">
          <div class="invalid-feedback" style="display: block">
            @if (hasError('lastName', 'required')) {
              {{ 'ContactAssessor.Required' | translate}}
            }
          </div>
        </div>
      </div>
      <div class="form-group" style="margin-bottom: 20px;">
        <p class="form-label">{{ 'ContactAssessor.Email' | translate}} <span class="color-red">*</span></p>
        <input type="email" class="form-control" formControlName="email" placeholder="{{'ContactAssessor.Email' | translate}}">
        <div class="invalid-feedback" style="display: block">
          @if (hasError('email', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
        </div>
      </div>
      <p class="form-label">{{ 'ContactAssessor.Phone' | translate}}  <span class="color-red">*</span></p>
      <div class="form-row" style="margin-bottom: 20px;">
        <div class="form-group col-12">
          <input class="form-control"  type="text" appPhoneMask placeholder="{{'ContactAssessor.Phone' | translate}}"  formControlName="phone" id="inputPhone-General"  >
          <div class="invalid-feedback" style="display: block">
            @if (hasError('phone', 'required')) {
              {{ 'ContactAssessor.Required' | translate}}
            }
          </div>
        </div>
      </div>

      <div class="form-group" style="margin-bottom: 20px;">
        <p class="form-label">AIN ({{ 'ContactAssessor.Ain' | translate}})<!--<span class="color-red">*</span>--></p>
        <input type="text" class="form-control" appAinMask formControlName="ain" placeholder="XXXX-XXX-XXX">
        <!-- <div class="invalid-feedback" style="display: block">
        <ng-container *ngIf="hasError('email', 'required')">{{ 'ContactAssessor.Required' | translate}} </ng-container>
      </div> -->
    </div>

    <p class="form-label">{{'ContactAssessor.Address'| translate}} <span class="color-red">*</span></p>
    <app-certificate-address
      [parentFormGroup]="contactForm"
      streetNumber="number"
      streetDirection="direction"
      streetName="street"
      streetType="type"
      unitNumber="unit"
      city="city"
      zipCode="zipCode"

      >
    </app-certificate-address>

    <p class="form-label" style="margin-top: 20px;">TOPIC OF REQUEST<span class="color-red">*</span></p>
    <div [ngClass]="requestValue === 'mailingaddress' ? 'alert-dark alert-trigger' : 'alert-dark'" class="alert  " (click)="changeRequest('mailingaddress')" role="alert">
      @if (requestValue === 'mailingaddress') {
        <i class="fas fa-check" style="font-size: .9rem;"></i>
        } Change of mailing address
      </div>
      <div [ngClass]="requestValue === 'buildingrecords' ? 'alert-dark alert-trigger' : 'alert-dark'" class="alert  " (click)="changeRequest('buildingrecords')" role="alert">
        @if (requestValue === 'buildingrecords') {
          <i class="fas fa-check" style="font-size: .9rem;"></i>
          } Request my property’s building records
        </div>
        <div [ngClass]="requestValue === 'propertyowner' ? 'alert-dark alert-trigger' : 'alert-dark'" class="alert  " (click)="changeRequest('propertyowner')" role="alert">
          @if (requestValue === 'propertyowner') {
            <i class="fas fa-check" style="font-size: .9rem;"></i>
            } Property owner's name
          </div>
          <div [ngClass]="requestValue === 'changedescription' ? 'alert-dark alert-trigger' : 'alert-dark'" class="alert  " (click)="changeRequest('changedescription')" role="alert">
            @if (requestValue === 'changedescription') {
              <i class="fas fa-check" style="font-size: .9rem;"></i>
              } Change to the description of your building or land data on the Assessor's records
            </div>
            <div [ngClass]="requestValue === 'mandc' ? 'alert-dark alert-trigger' : 'alert-dark'" class="alert  " (click)="changeRequest('mandc')" role="alert">
              @if (requestValue === 'mandc') {
                <i class="fas fa-check" style="font-size: .9rem;"></i>
                } Disaster relief (misfortune and calamity)
              </div>
              <div [ngClass]="requestValue === 'div' ? 'alert-dark alert-trigger' : 'alert-dark'" class="alert  " (click)="changeRequest('div')" role="alert">
                @if (requestValue === 'div') {
                  <i class="fas fa-check" style="font-size: .9rem;"></i>
                  } Decline-in-Value
                </div>
                <div [ngClass]="requestValue === 'disagree' ? 'alert-dark alert-trigger' : 'alert-dark'" class="alert  " (click)="changeRequest('disagree')" role="alert">
                  @if (requestValue === 'disagree') {
                    <i class="fas fa-check" style="font-size: .9rem;"></i>
                    } Disagree with recent assessment or valuation change of your property
                  </div>
                  <div [ngClass]="requestValue === 'other' ? 'alert-dark alert-trigger' : 'alert-dark'" class="alert  " (click)="changeRequest('other')" role="alert">
                    @if (requestValue === 'other') {
                      <i class="fas fa-check" style="font-size: .9rem;"></i>
                      } Other
                    </div>

                    <div class="invalid-feedback" style="display: block">
                      @if (hasError('request', 'required')) {
                        {{ 'ContactAssessor.Required' | translate}}
                      }
                    </div>

                    <!-- <p class="form-label">{{'ContactAssessor.RequestAddress' | translate}}<span class="color-red">*</span></p>
                    <div class="form-group form-row">
                      <div class="col-auto">
                        <input class="mr-3" formControlName="requestAddress" value="Yes" name="requestAddress" type="radio">
                        <label class="form-check-label">Yes</label>
                      </div>

                      <div class="col-auto">
                        <input class="mx-3" formControlName="requestAddress" value="No"  name="requestAddress"  type="radio">
                        <label class="form-check-label">No</label>
                      </div>
                      <div class="invalid-feedback" style="display: block">
                        <ng-container *ngIf="hasError('requestAddress', 'required')">{{ 'ContactAssessor.Required' | translate}}</ng-container>
                      </div>
                    </div>

                    <p class="form-label">{{'ContactAssessor.RadioOne' | translate}}<span class="color-red">*</span></p>
                    <div class="form-group form-row">
                      <div class="col-auto">
                        <input class="mr-3" formControlName="buildingOrLand" value="Yes" name="buildingOrLand" type="radio">
                        <label class="form-check-label">Yes</label>
                      </div>

                      <div class="col-auto">
                        <input class="mx-3" formControlName="buildingOrLand" value="No" name="buildingOrLand"  type="radio">
                        <label class="form-check-label">No</label>
                      </div>
                      <div class="invalid-feedback" style="display: block">
                        <ng-container *ngIf="hasError('buildingOrLand', 'required')">{{ 'ContactAssessor.Required' | translate}}</ng-container>
                      </div>
                    </div>
                    <p class="form-label">{{'ContactAssessor.RadioTwo' | translate}}<span class="color-red">*</span></p>
                    <div class="form-group form-row">
                      <div class="col-auto">
                        <input class="mr-3" formControlName="divormandc" value="Yes" name="divormandc" type="radio">
                        <label class="form-check-label">Yes</label>
                      </div>

                      <div class="col-auto">
                        <input class="mx-3" formControlName="divormandc" value="No"  name="divormandc"  type="radio">
                        <label class="form-check-label">No</label>
                      </div>
                      <div class="invalid-feedback" style="display: block">
                        <ng-container *ngIf="hasError('divormandc', 'required')">{{ 'ContactAssessor.Required' | translate}}</ng-container>
                      </div>
                    </div>
                    <p class="form-label">{{'ContactAssessor.RadioThree' | translate}}<span class="color-red">*</span></p>
                    <div class="form-group form-row">
                      <div class="col-auto">
                        <input class="mr-3" formControlName="disagreeValuation" value="Yes" name="disagreeValuation" type="radio">
                        <label class="form-check-label">Yes</label>
                      </div>

                      <div class="col-auto">
                        <input class="mx-3" formControlName="disagreeValuation" value="No"  name="disagreeValuation"  type="radio">
                        <label class="form-check-label">No</label>
                      </div>
                      <div class="invalid-feedback" style="display: block">
                        <ng-container *ngIf="hasError('disagreeValuation', 'required')">{{ 'ContactAssessor.Required' | translate}}</ng-container>
                      </div>
                    </div> -->
                    <p class="form-label">{{ 'ContactAssessor.Description' | translate}}</p>
                    <div class="form-group">

                      <textarea class="form-control" formControlName="description"  id="inputDescription-General" rows="4" placeholder="Type here"></textarea>
                    </div>
                    <p class="form-label" style="margin-top: 15px;">{{ 'ContactAssessor.Attachment' | translate}} (PDF or Docx)</p>
                    <div class="form-group" style="margin-top: 15px;">
                      <app-file-upload formControlName="file" [progress]="progress"></app-file-upload>
                      <div class="invalid-feedback" style="display: block">
                        @if (hasError('file', 'required')) {
                          {{ 'ContactAssessor.Required' | translate}}
                        }
                        @if (hasError('file', 'requiredFileType')) {
                          Only PDF, Docx
                        }
                        @if (hasError('file', 'requiredFileSize')) {
                          Size to exceeds 10 MB
                        }
                      </div>
                    </div>

                    <div class="form-group" style="margin-top: 15px;">
                      <app-captcha [form]="contactForm" captchaFieldName="recaptchaReactive"></app-captcha>
                      <div class="invalid-feedback" style="display: block">
                        @if (hasError('recaptchaReactive', 'required')) {
                          {{ 'ContactAssessor.Required' | translate}}
                        }
                      </div>
                    </div>

                    <button type="submit" class="btn btn-primary mr-4" style="margin-top: 15px;">Submit</button>@if (success) {
                    <span>Successfully Submitted</span>
                  }

                </form>

              </div>
